(function () {
  function el(t, c, x) { var e = document.createElement(t); if (c) e.className = c; if (x != null) e.textContent = x; return e; }

  // ── PayLater product search + Load More (progressive full load) ──────
  (function () {
    var input = document.getElementById('mh-plp-search-input');
    var grid  = document.getElementById('mh-plp-grid');
    var clear = document.getElementById('mh-plp-search-clear');
    var noRes = document.getElementById('mh-plp-noresults');
    var countEl = document.getElementById('mh-plp-count');
    var catSel  = document.getElementById('mh-plp-cat');
    var subSel  = document.getElementById('mh-plp-subcat');   // sub-category (dependent on the chosen category)
    var forcedHandle = '';   // set by a category card whose handle isn't in the tree (direct collection-handle filter)
    var forcedSub = '';      // sub-category forced by a card click — immune to the dropdown being rebuilt mid-load
    var pmin    = document.getElementById('mh-plp-pmin');
    var pmax    = document.getElementById('mh-plp-pmax');
    var sortSel = document.getElementById('mh-plp-sort');
    var availSel = document.getElementById('mh-plp-avail');   // In stock / Out of stock (offer pages)
    var brandSel = document.getElementById('mh-plp-brand');   // Brand filter (offer pages)
    var clearF  = document.getElementById('mh-plp-clear-filters');
    if (!grid) return;
    var total = parseInt(grid.getAttribute('data-total') || '0', 10) || 0;
    var baseCountText = countEl ? countEl.textContent : '';

    function cells() { return Array.prototype.slice.call(grid.querySelectorAll('.mh-plp-cell')); }

    // Stable original-order index so "Featured" order can be restored after a price sort.
    var idxSeq = 0;
    function indexCells() { cells().forEach(function (c) { if (c.dataset.mhIdx == null) c.dataset.mhIdx = String(idxSeq++); }); }

    // ── Admin-curated PayLater "Featured" pins ──────────────────────────────
    // offer-store.liquid exposes window.__mhPlFeatured (ordered handle list from
    // admin/paylater_featured → shop metafield) on /pages/paylater only. The SSR
    // renders these first, but once the JSON catalog loads the grid is rebuilt
    // from cardFromJson cells (no featured flag) in plain catalog order, so the
    // curated sequence is lost. These helpers let both the batch order and the
    // sort comparator pin featured products FIRST (default "Featured" sort only;
    // an explicit price sort still wins). Empty on every non-PayLater page.
    var PL_FEAT = (typeof window !== 'undefined' && Array.isArray(window.__mhPlFeatured)) ? window.__mhPlFeatured : [];
    var PL_FEAT_POS = Object.create(null);
    PL_FEAT.forEach(function (h, i) { if (h) PL_FEAT_POS[String(h).toLowerCase()] = i + 1; }); // 1-based; 0 = not featured
    function _plFeatPos(handle) { return handle ? (PL_FEAT_POS[String(handle).toLowerCase()] || 0) : 0; }
    function _cellHandle(c) {
      var a = c.querySelector('a[href*="/products/"]');
      var m = a ? (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/) : null;
      return m ? m[1] : '';
    }
    // Featured rank for a DOM cell (SSR cells have no data-mh-fpos → fall back to handle).
    function _cellFeatPos(c) {
      var fp = parseInt(c.getAttribute('data-mh-fpos') || '0', 10);
      return fp > 0 ? fp : _plFeatPos(_cellHandle(c));
    }

    // Category map: collection handle (at any depth) → top-level category name, from
    // the live category tree. Each product's categories are the intersection of its
    // collection handles with this map.
    var handleToTop = {}, topOrder = [], treeLoaded = false;
    // Sub-category (level-1) maps: a collection handle at any depth → the name of
    // its level-1 ancestor (the sub-category), and each top → its ordered subs.
    var handleToSub = {}, topToSubs = {};
    // Per-category tile artwork from the tree — powers the image-above-text
    // horizontal-scroll pill row rendered by renderCatNav().
    var topImage = {}, subImage = {};
    // A handle that lives under MORE THAN ONE category is ambiguous (e.g. a
    // generic "accessories" collection nested under both Mobiles and Computers).
    // We drop such handles from classification so a phone that merely carries a
    // generic collection isn't miscounted as a laptop.
    var topConflict = {}, subConflict = {};
    // Generic/marketing collections that must NEVER classify a product into a
    // category — e.g. a bare "accessories" collection the tree happens to nest
    // under Computers & Laptops, which was pulling phones into the Laptops list.
    var GENERIC_HANDLES = {
      'accessories': 1, 'menahub': 1, 'all': 1, 'sale': 1, 'on-sale': 1,
      'clearance': 1, 'new': 1, 'new-arrivals': 1, 'featured': 1, 'trending': 1,
      'best-sellers': 1, 'bestsellers': 1, 'top-rated': 1, 'deals': 1, 'offers': 1,
      'paylater': 1, 'mh-paylater': 1, 'pay-later': 1
    };
    function handleFromUrl(u) { var m = (u || '').match(/\/collections\/([^\/?#]+)/); return m ? m[1].toLowerCase() : ''; }
    function indexNode(node, topName) {
      var h = (node.handle || handleFromUrl(node.url) || '').toLowerCase();
      if (h) {
        if (handleToTop[h] !== undefined && handleToTop[h] !== topName) topConflict[h] = 1;
        else handleToTop[h] = topName;
      }
      (node.children || []).forEach(function (ch) { indexNode(ch, topName); });
    }
    function indexSubs(top) {
      var topName = top.name || '';
      (top.children || []).forEach(function (sub) {
        var subName = sub.name || '';
        if (!subName) return;
        (topToSubs[topName] = topToSubs[topName] || []).push(subName);
        if (sub.image_url) subImage[subName] = sub.image_url;
        (function mark(node) {
          var h = (node.handle || handleFromUrl(node.url) || '').toLowerCase();
          if (h) {
            if (handleToSub[h] !== undefined && handleToSub[h] !== subName) subConflict[h] = 1;
            else handleToSub[h] = subName;
          }
          (node.children || []).forEach(mark);
        })(sub);
      });
    }
    function pruneAmbiguousHandles() {
      Object.keys(topConflict).forEach(function (h) { delete handleToTop[h]; });
      Object.keys(subConflict).forEach(function (h) { delete handleToSub[h]; });
    }
    // ── Adaptive category depth (offer pages) ────────────────────────────
    // The strip renders exactly two levels: `topOrder` as tiles and
    // `topToSubs` as the row beneath. On a broad catalogue the tree roots are
    // the right tiles. On a single-brand offer they are useless: every Bose
    // product is "Tech & Gadgets" (51 of 55) and its only sub is "Audio"
    // (50 of 51), so the tiles divide nothing and the split that matters --
    // Earbuds 22 / Speakers 17 / Headphones 12 -- sits a level deeper and was
    // unreachable.
    //
    // So: pick the level that actually discriminates. Start at the roots and,
    // while one node holds nearly everything AND has at least two children
    // that themselves hold products, replace that node with its children.
    // Siblings are kept, so "TVs & Home Entertainment" survives alongside the
    // promoted audio categories.
    //
    // The six maps the renderer reads are then rebuilt to describe the chosen
    // level, so tiles, dropdowns and filtering all work unchanged -- this
    // changes WHICH level is called "top", not how any of it renders.
    var TREE_RAW = null, _adaptDone = false;
    // 0.7, not 0.8: Polti sits at 21 of 28 (75%) under Home & Kitchen
    // Appliances -- clearly a non-splitting tile, but 0.8 left it alone. At 0.7
    // Back to School still stays put (its biggest root is 433 of 757 = 57%),
    // which is the behaviour we want: only re-level pages that need it.
    var ADAPT_DOMINANCE = 0.7;
    var ADAPT_MAX_DEPTH = 5;

    function mhAdaptCategoryDepth() {
      // Offer-store pages carry data-mh-pid on cells and own their own category
      // classification (offer-store.liquid → api/offer_categories.php). Leave their
      // cells alone so the two systems don't clobber each other.
      if (document.querySelector('.mh-ochips')) return false;
      if (_adaptDone || !_offerEager) return false;
      if (!TREE_RAW || !CATALOG_LOADED || !CATALOG) return false;

      var reg = [];
      function walk(node, parent) {
        var id = reg.length;
        reg.push({ name: node.name || '', image: node.image_url || '', parent: parent, children: [], handles: [] });
        var h = (node.handle || handleFromUrl(node.url) || '').toLowerCase();
        if (h) reg[id].handles.push(h);
        (node.children || []).forEach(function (ch) { reg[id].children.push(walk(ch, id)); });
        return id;
      }
      var roots = TREE_RAW.map(function (n) { return walk(n, -1); });

      // handle -> node, dropping handles that appear under more than one node
      // (same rule as pruneAmbiguousHandles, for the same reason).
      var h2n = {}, dupe = {};
      reg.forEach(function (n, i) {
        n.handles.forEach(function (h) {
          if (h2n[h] !== undefined && h2n[h] !== i) dupe[h] = 1; else h2n[h] = i;
        });
      });
      Object.keys(dupe).forEach(function (h) { delete h2n[h]; });

      // Count products per node INCLUDING ancestors, so a product tagged
      // "earbuds" also counts toward Audio and Tech & Gadgets.
      var count = {}, classified = 0;
      Object.keys(CATALOG).forEach(function (ph) {
        var hit = {};
        (CATALOG[ph].cs || '').toLowerCase().split(/\s+/).forEach(function (h) {
          if (!h || GENERIC_HANDLES[h]) return;
          var id = h2n[h];
          if (id === undefined) return;
          while (id !== -1) { hit[id] = 1; id = reg[id].parent; }
        });
        var ks = Object.keys(hit);
        if (!ks.length) return;
        classified++;
        ks.forEach(function (k) { count[k] = (count[k] || 0) + 1; });
      });
      if (!classified) return false;

      var level = roots.filter(function (id) { return (count[id] || 0) > 0; });
      for (var g = 0; g < ADAPT_MAX_DEPTH; g++) {
        if (!level.length) return false;
        var dom = level.reduce(function (a, b) { return (count[b] || 0) > (count[a] || 0) ? b : a; });
        if ((count[dom] || 0) < ADAPT_DOMINANCE * classified) break;
        var kids = reg[dom].children.filter(function (id) { return (count[id] || 0) > 0; });
        // A single populated child is a level that splits nothing, so pass
        // straight through it rather than stopping. This is the Bose case:
        // Tech & Gadgets has exactly one populated child (Audio), and the
        // split that matters -- Earbuds / Speakers / Headphones -- is below
        // THAT. Requiring two children here left the tiles useless.
        if (kids.length < 1) break;
        level = kids.concat(level.filter(function (id) { return id !== dom; }));
      }
      // Still at the tree roots means this page's top level already
      // discriminates (Back to School: 12 categories, biggest 57%). Leave it
      // completely alone rather than rebuilding the maps for no gain.
      if (level.every(function (id) { return reg[id].parent === -1; })) {
        _adaptDone = true;
        return false;
      }

      function eachHandle(id, cb) {
        reg[id].handles.forEach(cb);
        reg[id].children.forEach(function (c) { eachHandle(c, cb); });
      }

      var nTop = {}, nSub = {}, cTop = {}, cSub = {};
      topOrder = []; topImage = {}; topToSubs = {}; subImage = {};
      level.forEach(function (id) {
        var name = reg[id].name;
        if (!name) return;
        topOrder.push(name);
        if (reg[id].image) topImage[name] = reg[id].image;
        eachHandle(id, function (h) {
          if (nTop[h] !== undefined && nTop[h] !== name) cTop[h] = 1; else nTop[h] = name;
        });
        var subs = [];
        reg[id].children.forEach(function (cid) {
          if (!(count[cid] > 0) || !reg[cid].name) return;
          subs.push(reg[cid].name);
          if (reg[cid].image) subImage[reg[cid].name] = reg[cid].image;
          eachHandle(cid, function (h) {
            if (nSub[h] !== undefined && nSub[h] !== reg[cid].name) cSub[h] = 1; else nSub[h] = reg[cid].name;
          });
        });
        if (subs.length) topToSubs[name] = subs;
      });
      Object.keys(cTop).forEach(function (h) { delete nTop[h]; });
      Object.keys(cSub).forEach(function (h) { delete nSub[h]; });
      handleToTop = nTop; handleToSub = nSub;

      // Cached per-cell classification is now stale.
      cells().forEach(function (c) { delete c.dataset.mhCat; delete c.dataset.mhSub; });
      _adaptDone = true;
      return true;
    }

    function deriveCats() {
      if (!treeLoaded) return;
      if (document.querySelector('.mh-ochips')) return; // offer-store pages self-classify
      cells().forEach(function (c) {
        if (c.dataset.mhCat != null) return;
        var set = {}, subset = {};
        (c.getAttribute('data-mh-cols') || '').toLowerCase().split(/\s+/).forEach(function (h) {
          if (!h || GENERIC_HANDLES[h]) return;
          if (handleToTop[h]) set[handleToTop[h]] = 1;
          if (handleToSub[h]) subset[handleToSub[h]] = 1;
        });
        c.dataset.mhCat = Object.keys(set).join('|');
        c.dataset.mhSub = Object.keys(subset).join('|');
      });
    }
    function refreshCatOptions() {
      if (!catSel) return;
      deriveCats();
      // Populate options from BOTH the DOM cells AND (when loaded) the full
      // JSON catalog. Assigning catSel.value to a top that isn't in options is
      // silently dropped by the browser — so exposing every catalog cat here
      // guarantees the pill row's click always registers.
      var present = {};
      cells().forEach(function (c) { (c.dataset.mhCat || '').split('|').forEach(function (x) { if (x) present[x] = 1; }); });
      if (CATALOG_LOADED && CATALOG) {
        Object.keys(CATALOG).forEach(function (h) {
          (CATALOG[h].cs || '').toLowerCase().split(/\s+/).forEach(function (hd) {
            if (!hd || GENERIC_HANDLES[hd]) return;
            if (handleToTop[hd]) present[handleToTop[hd]] = 1;
          });
        });
      }
      var cur = catSel.value;
      while (catSel.firstChild) catSel.removeChild(catSel.firstChild);
      var o0 = document.createElement('option'); o0.value = ''; o0.textContent = 'All categories'; catSel.appendChild(o0);
      topOrder.forEach(function (n) { if (!present[n]) return; var o = document.createElement('option'); o.value = n; o.textContent = n; if (n === cur) o.selected = true; catSel.appendChild(o); });
    }

    // Sub-category options depend on the chosen category: only the level-1 subs
    // of the selected top that are actually present among the loaded products.
    // Hidden entirely when no category is chosen or the category has no subs.
    function refreshSubOptions() {
      if (!subSel) return;
      deriveCats();
      var top = catSel ? catSel.value : '';
      var cur = subSel.value;
      var wrap = subSel.closest ? subSel.closest('.mh-plp-fgroup') : null;
      if (!top) {
        while (subSel.firstChild) subSel.removeChild(subSel.firstChild);
        var oz = document.createElement('option'); oz.value = ''; oz.textContent = subSel.getAttribute('data-all') || 'All sub-categories'; subSel.appendChild(oz);
        subSel.value = '';
        subSel.style.display = 'none'; if (wrap) wrap.style.display = 'none';
        return;
      }
      var present = {};
      cells().forEach(function (c) {
        if (('|' + (c.dataset.mhCat || '') + '|').indexOf('|' + top + '|') === -1) return;
        (c.dataset.mhSub || '').split('|').forEach(function (x) { if (x) present[x] = 1; });
      });
      // Also merge subs known from the JSON catalog so sub-cats are always
      // available even before we've rendered the matching product cells.
      if (CATALOG_LOADED && CATALOG) {
        Object.keys(CATALOG).forEach(function (h) {
          var handles = (CATALOG[h].cs || '').toLowerCase().split(/\s+/);
          var isInTop = false, recSubs = {};
          handles.forEach(function (hd) {
            if (!hd || GENERIC_HANDLES[hd]) return;
            if (handleToTop[hd] === top) isInTop = true;
            if (handleToSub[hd]) recSubs[handleToSub[hd]] = 1;
          });
          if (isInTop) Object.keys(recSubs).forEach(function (s) { present[s] = 1; });
        });
      }
      while (subSel.firstChild) subSel.removeChild(subSel.firstChild);
      var o0 = document.createElement('option'); o0.value = ''; o0.textContent = subSel.getAttribute('data-all') || 'All sub-categories'; subSel.appendChild(o0);
      var seen = {};
      (topToSubs[top] || []).forEach(function (n) {
        // Show sub-categories present among loaded products, PLUS the currently
        // selected one (so a card-driven selection keeps its option even before
        // its products have finished streaming in).
        if (seen[n] || !(present[n] || n === cur)) return; seen[n] = 1;
        var o = document.createElement('option'); o.value = n; o.textContent = n; if (n === cur) o.selected = true; subSel.appendChild(o);
      });
      var has = subSel.options.length > 1;
      if (cur && !seen[cur]) subSel.value = '';
      subSel.style.display = has ? '' : 'none'; if (wrap) wrap.style.display = has ? '' : 'none';
    }

    // Brand options come from data-mh-brand, which is the BRAND (product.type) —
    // never the vendor. product.type is what the whole store treats as the
    // brand: the PDP brand row links to /collections/types?q=<type>, and
    // /collections/<brand> is a smart collection on TYPE EQUALS <BRAND>.
    // Vendors are our suppliers and must never be shown to shoppers.
    var brandsSeen = {};
    function refreshBrandOptions() {
      if (!brandSel) return;
      var added = false;
      cells().forEach(function (c) {
        var v = (c.getAttribute('data-mh-brand') || '').trim();
        if (v && !brandsSeen[v]) { brandsSeen[v] = 1; added = true; }
      });
      if (!added && brandSel.options.length > 1) return;
      var cur = brandSel.value;
      var names = Object.keys(brandsSeen).sort();
      while (brandSel.firstChild) brandSel.removeChild(brandSel.firstChild);
      var o0 = document.createElement('option'); o0.value = ''; o0.textContent = brandSel.getAttribute('data-all') || 'All brands'; brandSel.appendChild(o0);
      names.forEach(function (n) {
        var o = document.createElement('option'); o.value = n;
        o.textContent = n.replace(/\b\w/g, function (m) { return m.toUpperCase(); });
        if (n === cur) o.selected = true; brandSel.appendChild(o);
      });
    }

    function activeFilters() {
      return !!((input && input.value.trim()) || (catSel && catSel.value) || (subSel && subSel.value) || forcedSub || forcedHandle || (availSel && availSel.value) || (brandSel && brandSel.value) || (pmin && pmin.value) || (pmax && pmax.value) || (sortSel && sortSel.value) || (typeof window !== 'undefined' && window.__mhCatFilter));
    }
    // Offer pages eagerly load every page and want a clean "all in-stock, then
    // all sold-out" order even mid-load — so sold-out cells stay hidden until the
    // full list has arrived (see the guard in apply()).
    var _offerEager = /\/pages\/offers(\/|$)/.test(location.pathname);
    function mhSearchStem(w){w=(w||'').toLowerCase();if(w.length<4)return w;if(w.slice(-3)==='ies')return w.slice(0,-3);if(/(ch|sh|ss|x|z)es$/.test(w))return w.slice(0,-2);if(w.slice(-1)==='s'&&w.slice(-2)!=='ss')return w.slice(0,-1);return w;}
    function apply() {
      deriveCats();
      refreshBrandOptions(); refreshCatOptions(); refreshSubOptions();
      var q   = input ? input.value.trim().toLowerCase() : '';
      var cat = catSel ? catSel.value : '';
      var sub = forcedSub || (subSel ? subSel.value : '');
      var av  = availSel ? availSel.value : '';   // '', 'in', 'out'
      var br  = brandSel ? brandSel.value : '';   // lowercase vendor
      var mn  = (pmin && pmin.value !== '') ? parseFloat(pmin.value) * 100 : null; // price stored in cents
      var mx  = (pmax && pmax.value !== '') ? parseFloat(pmax.value) * 100 : null;
      var list = cells(), shown = 0;
      list.forEach(function (c) {
        var ok = true;
        if (q) { var _hay = ((c.getAttribute('data-mh-title') || '') + ' ' + (c.getAttribute('data-mh-vendor') || '')).toLowerCase(); var _qt = q.split(/\s+/); for (var _qi = 0; _qi < _qt.length; _qi++) { var _s = mhSearchStem(_qt[_qi]); if (_s && _hay.indexOf(_s) === -1) { ok = false; break; } } }
        if (ok && cat && ('|' + (c.dataset.mhCat || '') + '|').indexOf('|' + cat + '|') === -1) ok = false;
        if (ok && sub && ('|' + (c.dataset.mhSub || '') + '|').indexOf('|' + sub + '|') === -1) ok = false;
        if (ok && forcedHandle && (' ' + (c.getAttribute('data-mh-cols') || '').toLowerCase() + ' ').indexOf(' ' + forcedHandle + ' ') === -1) ok = false;
        if (ok && av) { var avl = c.getAttribute('data-mh-available') !== 'false'; if (av === 'in' && !avl) ok = false; if (av === 'out' && avl) ok = false; }
        if (ok && br && (c.getAttribute('data-mh-brand') || '') !== br) ok = false;
        if (ok && (mn !== null || mx !== null)) { var p = parseFloat(c.getAttribute('data-mh-price') || '0'); if (mn !== null && p < mn) ok = false; if (mx !== null && p > mx) ok = false; }
        // Sold-out cells used to be hidden on offer pages until every page had
        // loaded, so they could never appear before all in-stock ones. That was
        // safe while the page eager-loaded everything, but with 20-per-page
        // loading `allLoaded` stays false until the shopper clicks through the
        // whole collection -- so a page of 20 rendered only its in-stock subset
        // (12 of 20 on Back to School). The sort below already forces sold-out
        // last within whatever is loaded, which is the correct behaviour for
        // progressive loading, so the extra hiding rule is gone.
        c.classList.toggle('mh-plp-hidden', !ok);
        if (ok) shown++;
      });
      var sv = sortSel ? sortSel.value : '';
      // Out-of-stock always sorts last, regardless of the chosen sort mode
      // (price asc/desc or featured) — availability is the primary sort key,
      // the user's chosen field only orders within each availability group.
      var sorted = list.slice().sort(function (a, b) {
        var aAvail = a.getAttribute('data-mh-available') !== 'false';
        var bAvail = b.getAttribute('data-mh-available') !== 'false';
        if (aAvail !== bAvail) return aAvail ? -1 : 1;
        if (sv === 'price-asc' || sv === 'price-desc') {
          var pa = parseFloat(a.getAttribute('data-mh-price') || '0'), pb = parseFloat(b.getAttribute('data-mh-price') || '0');
          return sv === 'price-asc' ? pa - pb : pb - pa;
        }
        // Default ("Featured") sort: admin-curated PayLater pins come first, in
        // their curated order, ahead of the collection's own order.
        if (PL_FEAT.length) {
          var fa = _cellFeatPos(a), fb = _cellFeatPos(b);
          if ((fa > 0) !== (fb > 0)) return fa > 0 ? -1 : 1;
          if (fa > 0 && fb > 0) return fa - fb;
        }
        return parseInt(a.dataset.mhIdx || '0', 10) - parseInt(b.dataset.mhIdx || '0', 10);
      });
      sorted.forEach(function (c) { grid.appendChild(c); });
      // Offer pages: present the fully-loaded, in-stock-first list as NUMBERED
      // client-side pages (real page buttons, not endless scroll). Slices the
      // filtered+sorted set — page 1 = first 50 in-stock, and so on.
      paginateClient(sorted);
      if (noRes) noRes.style.display = (shown === 0) ? '' : 'none';
      if (countEl) {
        // When filtering with the catalog loaded, use the TRUE total match count
        // (every catalog handle that passes the filter) — not the count of cells
        // currently in the DOM. Otherwise the top chip lies (says "22 of 52")
        // while the Load-more hint below correctly shows "627 more remaining".
        if (activeFilters()) {
          var denom = (_filterHandles && _filterHandles.length) ? _filterHandles.length : list.length;
          countEl.textContent = shown + ' of ' + denom + ' matches';
        } else {
          countEl.textContent = baseCountText;
        }
      }
      if (clearF) clearF.style.display = activeFilters() ? '' : 'none';
      if (clear) clear.style.display = q ? 'flex' : 'none';
      // While the user is typing a search, hide the top image banner + the
      // purple how-it-works band to surface results sooner. Restored on clear.
      var _bn  = document.getElementById('mh-plp-banner');
      var _how = document.querySelector('.mh-plp-how');
      if (_bn)  _bn.style.display  = q ? 'none' : '';
      if (_how) _how.style.display = q ? 'none' : '';
      renderCatNav();
    }

    // ── Dynamic category strip (horizontal-scrollable, mobile-first) ──
    // Populates #mh-plp-catnav with two rows of pills: top-level categories
    // present in the loaded products, and — when a top is selected — its
    // sub-categories. Chip clicks set the same catSel/subSel state the
    // dropdowns use, so filtering stays a single code path (run() → apply()).
    // Fed by both the SSR cells and the JSON catalog once loaded, so the strip
    // shows every cat/sub the collection actually contains, not just page 1's.
    function renderCatNav() {
      var nav = document.getElementById('mh-plp-catnav');
      if (!nav || !treeLoaded) return;
      // Hold the render until the JSON catalog lands (or fails outright) —
      // otherwise the strip paints with just the ~30 SSR cells' cats, then
      // rewrites seconds later with the full set, which reads as a flicker
      // to the shopper. The skeleton stays visible during this hold (rendered
      // in Liquid), so the section reserves its space and there's no layout
      // shift either. If the JSON path errors, fall back to whatever the SSR
      // cells alone can tell us so the strip isn't empty forever.
      if (!CATALOG_LOADED && !CATALOG_FAILED) return;
      var body = nav.querySelector('.mh-plp-catnav-body');
      if (!body) { body = document.createElement('div'); body.className = 'mh-plp-catnav-body'; nav.appendChild(body); }
      var presentTops = {}, presentSubsByTop = {};
      // From SSR + JSON-injected cells already in DOM.
      cells().forEach(function (c) {
        var ct = (c.dataset.mhCat || '').split('|');
        var st = (c.dataset.mhSub || '').split('|');
        ct.forEach(function (x) {
          if (!x) return;
          presentTops[x] = 1;
          (presentSubsByTop[x] = presentSubsByTop[x] || {});
          st.forEach(function (y) { if (y) presentSubsByTop[x][y] = 1; });
        });
      });
      // From the JSON catalog (products we haven't rendered as cells yet).
      if (CATALOG_LOADED && CATALOG) {
        Object.keys(CATALOG).forEach(function (h) {
          var rec = CATALOG[h];
          var handles = (rec.cs || '').toLowerCase().split(/\s+/);
          var recTops = {}, recSubs = {};
          handles.forEach(function (hd) {
            if (!hd || GENERIC_HANDLES[hd]) return;
            if (handleToTop[hd]) recTops[handleToTop[hd]] = 1;
            if (handleToSub[hd]) recSubs[handleToSub[hd]] = 1;
          });
          Object.keys(recTops).forEach(function (t) {
            presentTops[t] = 1;
            (presentSubsByTop[t] = presentSubsByTop[t] || {});
            Object.keys(recSubs).forEach(function (s) { presentSubsByTop[t][s] = 1; });
          });
        });
      }
      var tops = topOrder.filter(function (t) { return presentTops[t]; });
      var curTop = (catSel && catSel.value) || '';
      var curSub = forcedSub || (subSel && subSel.value) || '';
      var allLabel = (nav.getAttribute('data-lbl-all') || 'All');
      // Rebuild ONLY when the rendered content would actually differ. apply()
      // runs on every batch/sort/search tick; blindly wiping body.innerHTML each
      // time destroyed the tile the shopper was mid-click on and threw away
      // their horizontal scroll position.
      var subsForSig = curTop ? (topToSubs[curTop] || []).filter(function (s) { return presentSubsByTop[curTop] && presentSubsByTop[curTop][s]; }) : [];
      var sig = tops.join('') + '' + curTop + '' + curSub + '' + subsForSig.join('');
      if (nav.dataset.sig === sig && body.children.length) return;
      nav.dataset.sig = sig;
      // Preserve each row's horizontal scroll offset across the rebuild. The
      // <head> with the "Shop by Category" title lives outside
      // .mh-plp-catnav-body, so it never blinks.
      var prevScroll = {};
      body.querySelectorAll('.mh-plp-catnav-row').forEach(function (r, i) { prevScroll[i] = r.scrollLeft; });
      body.innerHTML = '';
      function mk(label, val, active, kind, image) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mh-plp-chip mh-plp-tile' + (active ? ' is-active' : '') + (image ? '' : ' mh-plp-tile--noimg');
        b.setAttribute('data-val', val);
        b.setAttribute('data-kind', kind);
        b.setAttribute('title', label);
        if (image) {
          var im = document.createElement('img');
          im.className = 'mh-plp-tile-img';
          im.src = image;
          im.alt = '';
          im.loading = 'lazy';
          im.width = 44; im.height = 44;
          b.appendChild(im);
        }
        var lbl = document.createElement('span');
        lbl.className = 'mh-plp-tile-lbl';
        lbl.textContent = label;
        b.appendChild(lbl);
        return b;
      }
      var topRow = document.createElement('div');
      topRow.className = 'mh-plp-catnav-row mh-plp-catnav-tops';
      topRow.appendChild(mk(allLabel, '', !curTop, 'top', null));
      tops.forEach(function (t) { topRow.appendChild(mk(t, t, curTop === t, 'top', topImage[t])); });
      body.appendChild(topRow);
      if (curTop) {
        var subs = (topToSubs[curTop] || []).filter(function (s) { return presentSubsByTop[curTop] && presentSubsByTop[curTop][s]; });
        if (subs.length) {
          var subRow = document.createElement('div');
          subRow.className = 'mh-plp-catnav-row mh-plp-catnav-subs';
          subRow.appendChild(mk(allLabel + ' ' + curTop, '', !curSub, 'sub', null));
          subs.forEach(function (s) { subRow.appendChild(mk(s, s, curSub === s, 'sub', subImage[s])); });
          body.appendChild(subRow);
        }
      }
      body.querySelectorAll('.mh-plp-catnav-row').forEach(function (r, i) { if (prevScroll[i] != null) r.scrollLeft = prevScroll[i]; });
      if (!nav.dataset.wired) {
        nav.dataset.wired = '1';
        nav.addEventListener('click', function (e) {
          var b = e.target && e.target.closest ? e.target.closest('.mh-plp-chip') : null;
          if (!b) return;
          var kind = b.getAttribute('data-kind');
          var val = b.getAttribute('data-val') || '';
          // Refresh options against the JSON catalog so the <select> accepts
          // ANY top from the tree (otherwise assigning a value not in the
          // options list is silently dropped and the filter never applies).
          // No cell dump — the batch renderer in run() handles that.
          if (CATALOG_LOADED) { refreshCatOptions(); refreshSubOptions(); }
          if (kind === 'top') {
            forcedHandle = ''; forcedSub = '';
            if (catSel) catSel.value = val;
            if (subSel) subSel.value = '';
            if (val) refreshSubOptions();
          } else if (kind === 'sub') {
            forcedSub = val;
            if (subSel) subSel.value = val;
          }
          run();
        });
      }
    }
    // ── Client-side numbered pagination (offer pages only) ───────────────
    // The offer page loads the full list and sorts it in-stock-first; we then
    // show it as clickable numbered pages instead of infinite scroll. Only the
    // current page's cells stay visible; the rest are hidden (not removed).
    var CPAGE_SIZE = 100000, cpage = 1, cpager = null;
    function paginateClient(sorted) {
      if (!_offerEager) { if (cpager) { cpager.style.display = 'none'; } return; }
      // Cap the visible grid to the current page's slice AT ALL TIMES — even
      // while the remaining pages load in the background — so the list never
      // grows into a long scroll that later "snaps" into pagination. From first
      // paint the shopper sees one page (up to 50), with the spinner below.
      var vis = sorted.filter(function (c) { return !c.classList.contains('mh-plp-hidden'); });
      var pages = Math.ceil(vis.length / CPAGE_SIZE) || 1;
      if (cpage > pages) cpage = pages;
      if (cpage < 1) cpage = 1;
      var start = (cpage - 1) * CPAGE_SIZE, end = start + CPAGE_SIZE;
      vis.forEach(function (c, i) { if (i < start || i >= end) c.classList.add('mh-plp-hidden'); });
      // The numbered pager is only correct once every page is loaded (final page
      // count is known). Until then keep it hidden and let the spinner show.
      if (allLoaded) {
        var _ld = document.getElementById('mh-plp-loading'); if (_ld) _ld.remove();
        renderPager(pages);
      } else if (cpager) {
        cpager.style.display = 'none';
      }
    }
    function renderPager(pages) {
      if (!cpager) {
        cpager = document.createElement('nav');
        cpager.id = 'mh-plp-cpager'; cpager.className = 'mh-ofp';
        cpager.setAttribute('aria-label', 'Product pagination');
        grid.insertAdjacentElement('afterend', cpager);
      }
      if (pages < 2) { cpager.style.display = 'none'; cpager.innerHTML = ''; return; }
      cpager.style.display = '';
      function cell(n, label, cur, off) {
        if (off) return '<span class="mh-ofp-a is-off" aria-hidden="true">' + label + '</span>';
        if (cur) return '<span class="mh-ofp-a is-cur" aria-current="page">' + label + '</span>';
        return '<a class="mh-ofp-a" href="#" data-cp="' + n + '">' + label + '</a>';
      }
      var parts = [cell(cpage - 1, '‹', false, cpage <= 1)];
      var win = [1], p;
      for (p = cpage - 1; p <= cpage + 1; p++) { if (p > 1 && p < pages) win.push(p); }
      win.push(pages);
      var last = 0;
      win.forEach(function (n) {
        if (n === last) return;
        if (n - last > 1) parts.push('<span class="mh-ofp-gap">…</span>');
        parts.push(cell(n, String(n), n === cpage, false));
        last = n;
      });
      parts.push(cell(cpage + 1, '›', false, cpage >= pages));
      cpager.innerHTML = parts.join('');
      [].slice.call(cpager.querySelectorAll('[data-cp]')).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var n = parseInt(b.getAttribute('data-cp'), 10);
          if (n >= 1 && n !== cpage) {
            cpage = n; apply();
            var top = document.getElementById('mh-plp-panel') || grid;
            if (top && top.scrollIntoView) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }

    // Grey-out the grid while the full catalogue streams in for a filter, so the
    // shopper sees a clear "loading this category" state instead of a flash of
    // partial/other-category results.
    function setBusy(on) {
      if (!grid) return;
      grid.style.transition = 'opacity .2s ease';
      grid.style.opacity = on ? '0.4' : '';
      grid.style.pointerEvents = on ? 'none' : '';
    }
    // Filters/sort/search apply across the WHOLE catalogue, so pull every page first.
    // Any filter/sort/search change resets to page 1.
    // Auto-load just enough pages IN THE BACKGROUND to show ~24 matches for the
    // active filter, then stop — the rest stream in as the shopper scrolls
    // (infinite scroll). Non-blocking: a category click never freezes the page,
    // and a sparse category (whose products sit deep in the collection) still
    // fills up instead of showing an empty grid.
    function fillToTarget(target) {
      target = target || 24;
      var loaded = 0, maxPages = 8;   // hard cap so a sparse category never full-loads
      function visN() { return cells().filter(function (c) { return !c.classList.contains('mh-plp-hidden'); }).length; }
      function step() {
        if (allLoaded || !activeFilters() || visN() >= target || loaded >= maxPages) return;
        loadNext().then(function (more) { loaded++; if (more) step(); });
      }
      step();
    }
    function run() {
      cpage = 1;
      // ── Catalog path (the normal case once JSON has landed) ──────────────
      // ONE mechanism owns the grid: computeFilterHandles() produces the
      // ordered match list — every catalog handle when no filter is set, the
      // matching subset when one is — and renderFilterBatch() pages through it
      // behind the "Load more" button. The Shopify HTML pager is retired here
      // so it can never append cells behind the batch renderer's back (that
      // was the "All + scroll re-loads everything" bug).
      if (CATALOG_LOADED) {
        retireSsrPager();
        _filterHandles = computeFilterHandles();
        _filterIdx = 0;
        // Drop every JSON-rendered cell so the grid restarts at page 1 for the
        // new filter — otherwise cells from the previous selection linger and
        // the counts drift.
        cells().forEach(function (c) { if (c.getAttribute('data-mh-json') === '1') c.remove(); });
        // Render a fuller FIRST screen straight from the in-memory catalog (it's
        // already cached, so this is cheap) — the grid looks instantly populated
        // instead of visibly counting up from 20. Scroll then loads more at
        // BATCH_SIZE. Capped so we never dump thousands of cells at once.
        renderFilterBatch(Math.min(BATCH_SIZE * 3, 60));
        // No drain on offer pages any more: the numbered pager it fed was never
        // reachable (CPAGE_SIZE 100000), so draining just dumped every match at
        // once. Offer pages now use the same Load-more batching as PayLater.
        apply();
        return;
      }
      // ── Pre-catalog fallback (JSON still in flight, or it failed) ─────────
      _filterHandles = null; _filterIdx = 0;
      if (_batchSentinel) _batchSentinel.style.display = 'none';
      if (_offerEager && activeFilters() && !allLoaded) { setBusy(true); loadAllThen(function () { apply(); setBusy(false); }); }
      else { apply(); if (activeFilters()) fillToTarget(24); }
    }

    // Let the offer page re-run the catalog filter after it sets window.__mhCatFilter
    // (a category-chip change), so the grid re-renders straight from the catalog.
    if (typeof window !== 'undefined') window.__mhPlpRun = function () { try { run(); } catch (e) {} };

    indexCells();
    // ?cb= is a cache-buster, not decoration. This host used to 301
    // /api/*.php to the clean URL, that redirect carried no CORS headers, and
    // Chrome caches a 301 PERMANENTLY -- so browsers that saw it once kept
    // failing the CORS check long after the server was fixed, and the category
    // strip silently never rendered. Incognito worked because its cache was
    // empty. Changing the URL is the only way to rescue an already-poisoned
    // cache. Bump cb if it ever recurs.
    var MH_TREE_API = 'https://admin.menahub.com/api/category_tree.php?cb=2';
    fetch(MH_TREE_API).then(function (r) { return r.json(); }).then(function (d) {
      var data = (d && d.data) ? d.data : (Array.isArray(d) ? d : []);
      TREE_RAW = data;
      data.forEach(function (top) {
        var name = top.name || '';
        if (name) topOrder.push(name);
        if (name && top.image_url) topImage[name] = top.image_url;
        indexNode(top, name);
        indexSubs(top);
      });
      pruneAmbiguousHandles();   // drop generic handles that map to several categories
      treeLoaded = true; mhAdaptCategoryDepth(); deriveCats(); refreshCatOptions(); refreshSubOptions(); apply();
    }).catch(function (e) {
      // Was an empty catch, which is why a hard CORS failure looked like
      // "the categories just don't show" instead of an error. The grid still
      // works without the tree, so this stays non-fatal — but it must be visible.
      console.error('[mh-plp] category tree failed to load — category filters unavailable', e);
    });

    // Hide the top banner + how-it-works band the instant there's search text —
    // independent of apply()/loadAllThen, which can lag seconds behind on a big
    // catalogue. (apply() also keeps these in sync after loads complete.)
    function toggleSearchBanners() {
      var hasQ = !!(input && input.value.trim());
      var bn  = document.getElementById('mh-plp-banner');
      var how = document.querySelector('.mh-plp-how');
      if (bn)  bn.style.display  = hasQ ? 'none' : '';
      if (how) how.style.display = hasQ ? 'none' : '';
    }

    var t;
    if (input) input.addEventListener('input', function () { toggleSearchBanners(); clearTimeout(t); t = setTimeout(run, 120); });
    if (clear) clear.addEventListener('click', function () { input.value = ''; toggleSearchBanners(); run(); if (input) input.focus(); });
    if (catSel) catSel.addEventListener('change', function () { forcedHandle = ''; forcedSub = ''; if (subSel) subSel.value = ''; run(); });
    if (subSel) subSel.addEventListener('change', function () { forcedSub = ''; run(); });
    if (availSel) availSel.addEventListener('change', run);
    if (brandSel) brandSel.addEventListener('change', run);
    if (sortSel) sortSel.addEventListener('change', run);
    var pt;
    function priceChanged() { clearTimeout(pt); pt = setTimeout(run, 250); }
    if (pmin) pmin.addEventListener('input', priceChanged);
    if (pmax) pmax.addEventListener('input', priceChanged);
    if (clearF) clearF.addEventListener('click', function () {
      if (input) input.value = ''; if (catSel) catSel.value = ''; if (subSel) subSel.value = ''; forcedHandle = ''; forcedSub = ''; if (availSel) availSel.value = ''; if (brandSel) brandSel.value = ''; if (pmin) pmin.value = ''; if (pmax) pmax.value = ''; if (sortSel) sortSel.value = '';
      cpage = 1; apply();
    });

    // ── Category links → filter IN PLACE (progressive enhancement) ──────────
    // Covers BOTH the image-card row (.mh-plcat) shown at the top and the text
    // pill nav (.mh-plp-cats) lower down. All are real /collections/<handle>
    // links (SEO + no-JS still work). Once the tree is loaded we intercept and
    // filter instead of navigating. Resolution, most precise first:
    //   handle → its sub-category (level-1)  → set Category + Sub-category
    //   handle → its top category            → set Category
    //   handle NOT in the tree               → direct collection-handle filter
    //   handle we truly can't place (e.g. "all") → let the link navigate
    function scrollToPanel() {
      var topEl = document.getElementById('mh-plp-panel') || grid;
      if (topEl && topEl.scrollIntoView) topEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function mhCatLinkClick(e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/collections/"]') : null;
      if (!a || !treeLoaded) return;                   // pre-tree clicks navigate normally
      var h = handleFromUrl(a.getAttribute('href') || '');
      if (!h || h === 'all') return;                   // "Shop all" etc. → navigate
      e.preventDefault();
      var top = handleToTop[h], sub = handleToSub[h];
      cpage = 1;
      if (top) {
        forcedHandle = '';
        // Force the sub-category via a dedicated flag so it can't be reset while
        // the grid streams in — narrows to e.g. laptops from the first render.
        forcedSub = (sub && (topToSubs[top] || []).indexOf(sub) !== -1) ? sub : '';
        if (catSel) catSel.value = top;
        refreshSubOptions();
        if (subSel) subSel.value = forcedSub;   // reflect in the dropdown (display only)
      } else {
        forcedHandle = h; forcedSub = ''; if (catSel) catSel.value = ''; if (subSel) subSel.value = '';
      }
      // Instant path when the JSON catalog is already loaded: route through
      // run() so the batched renderer + scroll sentinel take over. No cell
      // dump, no fetches, no lag.
      var finish = function () { apply(); scrollToPanel(); };
      if (CATALOG_LOADED) { run(); scrollToPanel(); return; }
      // Fallback: existing HTML-page load path.
      if (_offerEager && !allLoaded) { setBusy(true); loadAllThen(function () { finish(); setBusy(false); }); }
      else { finish(); fillToTarget(24); }
    }
    document.querySelectorAll('.mh-plp-cats, .mh-plcat').forEach(function (nav) {
      nav.addEventListener('click', mhCatLinkClick);
    });

    // Progressive loading: every paginated page is fetched and its product
    // cells appended, so ALL PayLater products end up in the DOM. Pages load
    // automatically as the Load-More sentinel nears the viewport (infinite
    // scroll); a search forces every remaining page to load first so it filters
    // the FULL catalogue, not just the first page.
    var btn = document.getElementById('mh-plp-loadmore');
    var loading = false;
    var allLoaded = !btn;

    function loadNext() {
      return new Promise(function (resolve) {
        if (loading || !btn) { resolve(false); return; }
        // While a filter is active, the JSON batch renderer owns the grid —
        // the HTML page loader would otherwise stream in every "All PayLater"
        // product in the background, defeating the whole point of filtering.
        if (CATALOG_LOADED && activeFilters()) { resolve(false); return; }
        var url = btn.getAttribute('data-next-url');
        if (!url) { if (btn) { btn.remove(); btn = null; } allLoaded = true; resolve(false); return; }
        loading = true;
        btn.disabled = true;
        btn.textContent = 'Loading…';
        fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            doc.querySelectorAll('#mh-plp-grid .mh-plp-cell').forEach(function (c) {
              grid.appendChild(document.importNode(c, true));
            });
            indexCells(); deriveCats();
            if (countEl && input && !input.value.trim()) {
              countEl.textContent = 'Showing ' + cells().length + ' of ' + total + ' products';
            }
            var nextBtn = doc.getElementById('mh-plp-loadmore');
            if (nextBtn && nextBtn.getAttribute('data-next-url')) {
              btn.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url'));
              btn.disabled = false; btn.textContent = 'Load more products';
            } else {
              btn.remove(); btn = null; allLoaded = true;
            }
            loading = false;
            apply();
            resolve(true);
          })
          .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'Load more products'; } loading = false; resolve(false); });
      });
    }

    // Infinite scroll: auto-load when the sentinel button approaches the viewport.
    // Retired the moment the JSON catalog lands (see retireSsrPager) — from then
    // on the batch renderer is the ONLY thing that appends cells, so the two
    // mechanisms can never fight over the grid.
    var _ssrIO = null;
    // Offer pages are click-only: you asked for a Load-more button at the
    // bottom "like pagination", and an 800px rootMargin would fetch the next
    // page long before the button scrolled into view, so the button would
    // effectively never be seen. PayLater already works this way.
    if (btn && !_offerEager && 'IntersectionObserver' in window) {
      _ssrIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) loadNext(); });
      }, { rootMargin: '800px 0px' });
      _ssrIO.observe(btn);
    }
    // Tear down the Shopify HTML pager: stop the observer, drop the button.
    // Called once the catalog is in memory.
    function retireSsrPager() {
      if (_ssrIO) { try { _ssrIO.disconnect(); } catch (e) {} _ssrIO = null; }
      var wrap = document.querySelector('.mh-plp-loadmore-wrap');
      if (wrap) wrap.remove();
      if (btn) { btn.remove(); btn = null; }
      // Drop the original SSR product cells — the catalog batch renderer now owns
      // the grid and emits its own (rich) JSON cards. Leaving the SSR cells in
      // double-counted every product ("21 of 11") and duplicated cards.
      try {
        var ssr = grid.querySelectorAll('.mh-plp-cell:not([data-mh-json="1"])');
        for (var i = 0; i < ssr.length; i++) ssr[i].parentNode && ssr[i].parentNode.removeChild(ssr[i]);
      } catch (e) {}
      allLoaded = true;
    }
    // Manual click still works (and as a fallback where IO is unsupported).
    if (btn) btn.addEventListener('click', function () { loadNext(); });

    // Offer pages (/pages/offers/*): eagerly pull EVERY page so the full list
    // settles into in-stock-first order (all in-stock, then all sold-out)
    // without the shopper having to scroll. apply() runs after each page and
    // keeps availability as the primary sort key. Storefront-only fetches — this
    // does not touch the Hostinger admin/API 408 path.
    // NOTE: this is a FUNCTION, invoked further down right after _catalogPromise
    // is assigned. Calling _catalogPromise.then() inline here threw
    // "Cannot read properties of undefined (reading 'then')" — `var` hoists the
    // declaration but not the assignment, and the assignment lives ~300 lines
    // below. The exception killed the rest of the script, which is why offer
    // pages rendered no category strip and no filtering at all.
    function initOfferEager() {
      // Offer pages only, and only when the pager button exists. Without this
      // guard the priming load below would also fire on PayLater, which owns
      // its own batching and must not have an extra HTML page pulled in.
      if (!btn || !_offerEager) return;
      // This used to inject a spinner and then call
      // drainFilterBatches(), which rendered EVERY product on first paint, and
      // paginateClient's CPAGE_SIZE of 100000 meant the promised numbered pager
      // never appeared either. Net effect: the whole collection dumped at once,
      // with no Load-more button anywhere.
      //
      // Offer pages now keep Shopify's own paginated HTML with the click-driven
      // Load-more button, so every card on the page is rendered by the same
      // product-card-new code and looks identical. The JSON catalog is still
      // prefetched, but it is only used to filter -- never to bulk-render the
      // unfiltered view.
      //
      // Offer pages must show ALL in-stock products before any sold-out one.
      // apply() sorts availability-first, but only across the cells currently in
      // the DOM — so with progressive loading a sold-out item on SSR page 1 can
      // sit above an in-stock item that only loads on a later page. So eagerly
      // pull EVERY page (each loadNext re-runs apply); once the full collection
      // is loaded the order settles to in-stock first, sold-out at the bottom.
      // SSR still renders the first page, so first paint / SEO are unaffected.
      if (!_offerPrimed) { _offerPrimed = true; loadAllThen(apply); }
    }
    var _offerPrimed = false;

    // Pull every remaining page (used before filtering a search query).
    function loadAllThen(cb) {
      if (allLoaded || !btn) { cb(); return; }
      loadNext().then(function (more) { if (more && !allLoaded) loadAllThen(cb); else cb(); });
    }

    // ── INSTANT CATALOG (JSON prefetch) ──────────────────────────────────
    // Replaces the sequential HTML page fetches (loadAllThen/loadNext) with a
    // single burst of parallel /collections/<handle>?view=pljson requests, so a
    // category / sub-cat / search click filters an in-memory index instead of
    // waiting on 20+ HTML page renders. First paint stays SSR (SEO intact);
    // the catalog just fills in what isn't in the DOM yet.
    var collectionHandle = (grid.getAttribute('data-collection') || '').trim();
    var CATALOG = null;            // { handle: {i,h,t,v,p,c,a,g,u,cs} }
    var CATALOG_LOADED = false;    // true once every JSON page has merged
    var CATALOG_FAILED = false;    // true if JSON prefetch errored — fallback path
    var CATALOG_TOTAL = 0;

    // 15-minute cache bucket — same URL for 15 minutes → Cloudflare + Shopify
    // serve one cached render for that window. Rolls forward automatically so
    // pricing / availability updates surface promptly without ever letting a
    // stale pre-deploy HTML response linger at the same cache key.
    var _catBucket = Math.floor(Date.now() / 900000);
    function _fetchPljson(page) {
      var u = '/collections/' + encodeURIComponent(collectionHandle) + '?view=pljson&page=' + page + '&b=' + _catBucket;
      // credentials:'omit' is CRITICAL — sending the HttpOnly _shopify_essential
      // session cookie routes the request through Shopify's personalized
      // rendering path, which ignores the ?view= alt template and returns the
      // full storefront HTML page instead. The catalog is public read-only data
      // so no cookies are needed.
      return fetch(u, { credentials: 'omit', headers: { 'X-Requested-With': 'fetch', 'Accept': '*/*' } })
        .then(function (r) { return r.text(); })
        .then(function (t) { try { return JSON.parse(t); } catch (e) { return null; } });
    }
    // sessionStorage cache key for the whole catalog — per collection + the same
    // rolling 15-min bucket the network fetch uses, so a repeat visit this session
    // (e.g. product-detail → back) restores every product from memory with no
    // fetch/parse at all. Rolls over automatically so prices never go stale.
    var _catCK = null;
    try { if (window.sessionStorage && collectionHandle) _catCK = 'mh_cat_' + collectionHandle + '_' + _catBucket; } catch (e) { _catCK = null; }
    function _storeCatalog() {
      try { if (_catCK && CATALOG) sessionStorage.setItem(_catCK, JSON.stringify({ c: CATALOG, n: CATALOG_TOTAL })); } catch (e) { /* quota / private mode — skip */ }
    }
    function prefetchCatalog() {
      if (!collectionHandle) return Promise.resolve(false);
      // Instant restore from this session's cache when available.
      try {
        if (_catCK) {
          var cached = sessionStorage.getItem(_catCK);
          if (cached) {
            var cd = JSON.parse(cached);
            if (cd && cd.c) {
              CATALOG = Object.assign(Object.create(null), cd.c);
              CATALOG_TOTAL = cd.n || Object.keys(CATALOG).length;
              CATALOG_LOADED = true;
              return Promise.resolve(true);
            }
          }
        }
      } catch (e) { /* fall through to network */ }
      return _fetchPljson(1).then(function (p1) {
        if (!p1 || !p1.products) return false;
        CATALOG = Object.create(null);
        p1.products.forEach(function (x) { if (x && x.h) CATALOG[x.h] = x; });
        CATALOG_TOTAL = p1.count || Object.keys(CATALOG).length;
        var pages = p1.pages || 1;
        if (pages <= 1) { CATALOG_LOADED = true; _storeCatalog(); return true; }
        var jobs = [];
        for (var n = 2; n <= pages; n++) jobs.push(_fetchPljson(n));
        return Promise.all(jobs).then(function (rest) {
          rest.forEach(function (p) { if (p && p.products) p.products.forEach(function (x) { if (x && x.h) CATALOG[x.h] = x; }); });
          CATALOG_LOADED = true;
          _storeCatalog();
          return true;
        });
      }).catch(function () { CATALOG_FAILED = true; return false; });
    }

    // Minimal card built from a JSON product record. Mirrors the .mh-plp-cell
    // wrapper contract (data-mh-* attrs) so the existing filter + sort code
    // treats it identically to an SSR product-card-new cell. The MutationObserver
    // already in this file picks these up on injection and clears the image
    // shimmer + wires the PayLater badge (non-offer only) via wireImgShimmer().
    function _esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
    function _priceQar(cents) { var q = (parseInt(cents, 10) || 0) / 100; return q >= 100 ? Math.round(q).toString() : q.toFixed(2); }
    // Deterministic rating/reviews/sold from product id — MUST match the exact
    // buckets in snippets/product-card-new.liquid so JSON cards read identically
    // to the SSR cards beside them.
    function _ratingFromId(id) { var m = id % 15; return m > 10 ? '4.8' : m > 7 ? '4.6' : m > 4 ? '4.3' : m > 2 ? '4.0' : '3.5'; }
    function _reviewsFromId(id) { var m = id % 25; return m > 20 ? '2.1K' : m > 15 ? '1.8K' : m > 10 ? '1.2K' : m > 5 ? '856' : '524'; }
    function _soldFromId(id) { var m = id % 30; return m > 25 ? '1,000+ sold' : m > 20 ? '500+ sold' : m > 15 ? '200+ sold' : m > 10 ? '100+ sold' : m > 5 ? '50+ sold' : '10+ sold'; }
    function cardFromJson(x) {
      var cell = document.createElement('div');
      cell.className = 'mh-plp-cell';
      cell.setAttribute('data-mh-json', '1');
      // Offer pages stamp/sort/filter cells by product id (data-mh-pid); the SSR
      // cells carry it, so JSON cards must too or they'd render un-categorised.
      cell.setAttribute('data-mh-pid', String(x.i || ''));
      cell.setAttribute('data-mh-available', x.a ? 'true' : 'false');
      cell.setAttribute('data-mh-title', (x.t || '').toLowerCase());
      cell.setAttribute('data-mh-vendor', (x.v || '').toLowerCase());
      // BRAND, not vendor. This read x.v (the vendor), so supplier names like
      // "Al Dura ( Al-Masa Computer Technology) Trading And Contracting" were
      // listed in the shopper-facing brand filter. The SSR cells have always
      // used product.type here; only the JSON cards diverged.
      cell.setAttribute('data-mh-brand', (x.b || '').toLowerCase());
      cell.setAttribute('data-mh-price', String(x.p || 0));
      cell.setAttribute('data-mh-cols', x.cs || '');
      // PayLater admin-curated pin: stamp the featured rank AND a negative CSS
      // `order` (-1000 + rank). The page orders cells visually by style.order
      // (data-mh-prio), NOT DOM position, and un-prioritised cells default to
      // order:9999 — so without this a featured card built from JSON sinks to the
      // bottom. A negative order keeps pins ahead of every chip/category order
      // (which start at 0). data-mh-prio also exempts the card from the presort
      // opacity:0 hide. See offer-store.liquid tagCellsWithPriority / rankBySearchQuery.
      var _fp = _plFeatPos(x.h);
      if (_fp) {
        var _fo = -1000 + _fp;
        cell.setAttribute('data-mh-featured', '1');
        cell.setAttribute('data-mh-fpos', String(_fp));
        cell.setAttribute('data-mh-prio', String(_fo));
        cell.style.order = String(_fo);
      }
      var hasCompare = x.c && x.c > x.p;
      // data-product-id and .mh-card-info are REQUIRED, not cosmetic:
      // mh-x-fulfilment-badge-hydrator-1.js selects
      // `.mh-card[data-product-id]` and injects the delivery bar into
      // `.mh-card-info`. Without them these cards silently never got a
      // "Delivery Tomorrow" strip while the SSR cards beside them did.
      //
      // The vendor name is deliberately NOT rendered: product-card-new never
      // shows it, so printing it here made JSON cards visibly different from
      // the real ones (the purple seller name in the middle of the grid).
      // Full rich card — mirrors snippets/product-card-new.liquid so it inherits
      // mh-product-card.css AND the delivery/badge/label hydrators (which key off
      // data-product-id / data-handle), plus a working add-to-cart form.
      var id = parseInt(x.i, 10) || 0;
      var rating = _ratingFromId(id), reviews = _reviewsFromId(id), sold = _soldFromId(id);
      var savings = hasCompare ? Math.round((x.c - x.p) * 100 / x.c) : 0;
      var badge = (typeof window !== 'undefined' && window.__mhOfferBadge) ? window.__mhOfferBadge : null;
      var pill = (badge && badge.text)
        ? '<a class="mh-offer-pill" href="/pages/offers/' + _esc(badge.slug || '') + '" style="background:' + _esc(badge.bg || '#B45309') + ';color:' + _esc(badge.fg || '#fff') + '">' + _esc(badge.text) + '</a>' : '';
      var quickAdd = (x.a && x.vid)
        ? '<form class="mh-quick-add-form" action="/cart/add" method="post"><input type="hidden" name="id" value="' + _esc(x.vid) + '"><button type="submit" class="mh-plus-icon" aria-label="Add to cart"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></button></form>' : '';
      var priceHtml = x.pl
        ? '<div class="mh-price-wrap mh-price-wrap--pl"><span class="mh-pl-monthly"><span class="mh-cur">QAR</span>' + _priceQar(Math.floor(x.p / 4)) + '<span class="mh-pl-mo">/mo</span><span class="mh-pl-x4">&times;4</span></span>' + (savings ? '<span class="mh-price-discount mh-price-discount--sm">-' + savings + '%</span>' : '') + '</div>'
        : '<div class="mh-price-wrap"><span class="mh-price-current"><span class="mh-cur">QAR</span>' + _priceQar(x.p) + '</span>' + (hasCompare ? '<span class="mh-price-old">QAR ' + _priceQar(x.c) + '</span><span class="mh-price-discount">-' + savings + '%</span>' : '') + '</div>';
      cell.innerHTML =
        '<div class="mh-card' + (x.a ? '' : ' is-oos') + '" data-product-id="' + _esc(x.i) + '" data-product-handle="' + _esc(x.h) + '" data-available="' + (x.a ? 'true' : 'false') + '">' +
          '<div class="mh-card-inner">' +
            '<div class="mh-card-image-wrap" data-carousel="false">' +
              pill +
              '<a href="' + _esc(x.u) + '" class="mh-carousel-container"><img class="mh-carousel-slide active" src="' + _esc(x.g) + '" alt="' + _esc(x.t) + '" width="600" height="600" loading="lazy" decoding="async"></a>' +
              '<div class="mh-dynamic-badges-img" data-handle="' + _esc(x.h) + '"></div>' +
              '<button class="mh-wishlist-btn" aria-label="Add to wishlist" data-product-id="' + _esc(x.i) + '"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg></button>' +
              quickAdd +
            '</div>' +
            '<div class="mh-card-info">' +
              '<h3 class="mh-card-title"><a href="' + _esc(x.u) + '">' + _esc(x.t) + '</a></h3>' +
              '<div class="mh-rating-wrap"><svg class="mh-star-icon" width="14" height="14" viewBox="0 0 24 24" fill="#22c55e" stroke="#22c55e" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg><span class="mh-rating-score">' + rating + '</span><span class="mh-rating-count">(' + reviews + ')</span><span class="mh-sold-count">| ' + sold + '</span></div>' +
              priceHtml +
              '<span class="mh-label-slot" data-product-id="' + _esc(x.i) + '"></span>' +
              (x.a ? '<div class="mh-delivery-strip mh-delivery-strip--edge" aria-hidden="true"></div>' : '<button type="button" class="mh-card-oos-bar mh-card-notify" data-notify-handle="' + _esc(x.h) + '">Notify me</button>') +
            '</div>' +
          '</div>' +
        '</div>';
      return cell;
    }

    // ── Progressive filter rendering (batches of BATCH_SIZE, sentinel-driven) ──
    // On filter change we compute the matching handle list from the JSON
    // catalog in memory, then append cells in batches of BATCH_SIZE as the
    // shopper scrolls. Much lighter on the browser than dumping all 2600+
    // matching cells into the DOM at once, and the first paint is instant.
    var BATCH_SIZE = 20;
    var _filterHandles = null;   // ordered handles matching the active filter
    var _filterIdx = 0;          // next unread position in _filterHandles
    var _batchSentinel = null;
    var _batchIO = null;

    function computeFilterHandles() {
      if (!CATALOG_LOADED || !CATALOG) return [];
      var q   = input ? input.value.trim().toLowerCase() : '';
      var cat = catSel ? catSel.value : '';
      var sub = forcedSub || (subSel ? subSel.value : '');
      var av  = availSel ? availSel.value : '';
      var br  = brandSel ? brandSel.value : '';
      var mn  = (pmin && pmin.value !== '') ? parseFloat(pmin.value) * 100 : null;
      var mx  = (pmax && pmax.value !== '') ? parseFloat(pmax.value) * 100 : null;
      var qTokens = q ? q.split(/\s+/).map(mhSearchStem).filter(Boolean) : [];
      var inStock = [], outStock = [];
      Object.keys(CATALOG).forEach(function (h) {
        var x = CATALOG[h];
        if (qTokens.length) {
          var hay = ((x.t || '') + ' ' + (x.v || '')).toLowerCase();
          for (var i = 0; i < qTokens.length; i++) if (hay.indexOf(qTokens[i]) === -1) return;
        }
        if (cat || sub || forcedHandle) {
          var handles = (x.cs || '').toLowerCase().split(/\s+/);
          var topsHit = {}, subsHit = {}, hasHandle = false;
          for (var j = 0; j < handles.length; j++) {
            var hd = handles[j];
            if (!hd || GENERIC_HANDLES[hd]) continue;
            if (handleToTop[hd]) topsHit[handleToTop[hd]] = 1;
            if (handleToSub[hd]) subsHit[handleToSub[hd]] = 1;
            if (hd === forcedHandle) hasHandle = true;
          }
          if (cat && !topsHit[cat]) return;
          if (sub && !subsHit[sub]) return;
          if (forcedHandle && !hasHandle) return;
        }
        if (av === 'in' && !x.a) return;
        if (av === 'out' && x.a) return;
        if (br && (x.b || '').toLowerCase() !== br) return;   // brand, not vendor
        if (mn !== null && x.p < mn) return;
        if (mx !== null && x.p > mx) return;
        // Offer-page category chips inject a predicate keyed by product id so a
        // category renders ONLY its products straight from the catalog — instant,
        // instead of rendering everything and hiding non-matches. PayLater never
        // sets this, so its behaviour is unchanged.
        if (window.__mhCatFilter && !window.__mhCatFilter(x)) return;
        (x.a ? inStock : outStock).push(h);
      });
      var sv = sortSel ? sortSel.value : '';
      if (sv === 'price-asc' || sv === 'price-desc') {
        var cmp = function (a, b) { var pa = (CATALOG[a] || {}).p || 0, pb = (CATALOG[b] || {}).p || 0; return sv === 'price-asc' ? pa - pb : pb - pa; };
        inStock.sort(cmp); outStock.sort(cmp);
      } else if (typeof window !== 'undefined' && typeof window.__mhCatOrder === 'function') {
        // Offer pages: render in the offer's category-tab priority order so the
        // FIRST batch is already correctly ordered (no "wrong products then they
        // reorder" flash on the All view).
        var co = window.__mhCatOrder;
        var cmp2 = function (a, b) { return (co(CATALOG[a]) || 0) - (co(CATALOG[b]) || 0); };
        inStock.sort(cmp2); outStock.sort(cmp2);
      }
      // PayLater default sort: hoist the admin-curated featured pins to the front
      // of the in-stock set (in their curated order) so the FIRST rendered batch
      // already leads with them — no "catalog order then reorder" flash. Only on
      // the default sort; an explicit price sort above already won. Stable: the
      // non-featured tail keeps its catalog order.
      if (PL_FEAT.length && sv !== 'price-asc' && sv !== 'price-desc') {
        inStock.sort(function (a, b) {
          var fa = PL_FEAT_POS[a] || 0, fb = PL_FEAT_POS[b] || 0;
          if ((fa > 0) !== (fb > 0)) return fa > 0 ? -1 : 1;
          if (fa > 0 && fb > 0) return fa - fb;
          return 0;
        });
      }
      return inStock.concat(outStock);
    }

    // Read the number of grid columns from the LIVE computed style so a batch
    // always ends on a full row (no orphan trailing cells). The grid uses
    // repeat(auto-fill, minmax(200px, 1fr)) — column count is 2 on mobile,
    // typically 3-6 on desktop depending on viewport width.
    function _gridColumns() {
      var s = getComputedStyle(grid).gridTemplateColumns || '';
      var n = s.trim().split(/\s+/).filter(Boolean).length;
      return Math.max(1, n);
    }

    // Append the next slice of matches. Single pass, NO recursion and NO nested
    // apply() — an earlier version recursed to fill the trailing row, and each
    // level re-ran apply() → renderCatNav() → catnav innerHTML wipe, which
    // destroyed the very tile the shopper had just clicked and pegged the main
    // thread. The row-fill maths is done up front instead.
    function _visibleCount() {
      return cells().filter(function (c) { return !c.classList.contains('mh-plp-hidden'); }).length;
    }
    // Append up to k catalog cells that aren't already rendered. Returns the
    // number actually appended.
    function _appendUpTo(k) {
      if (k <= 0 || !_filterHandles) return 0;
      var have = Object.create(null);
      cells().forEach(function (c) {
        var a = c.querySelector('a[href*="/products/"]');
        var m = a ? (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/) : null;
        if (m) have[m[1]] = 1;
      });
      var frag = document.createDocumentFragment();
      var added = 0;
      while (_filterIdx < _filterHandles.length && added < k) {
        var h = _filterHandles[_filterIdx++];
        if (!have[h] && CATALOG[h]) { frag.appendChild(cardFromJson(CATALOG[h])); added++; }
      }
      if (added) { grid.appendChild(frag); indexCells(); deriveCats(); }
      return added;
    }

    function renderFilterBatch(n) {
      if (!_filterHandles) return 0;
      var cols = _gridColumns();
      var visNow = _visibleCount();
      // Land the TOTAL visible count on a row boundary so the last row is full.
      var targetVisible = Math.ceil((visNow + n) / cols) * cols;
      var added = _appendUpTo(targetVisible - visNow);
      if (added) apply();
      // Top-up pass: apply()'s filtering/sorting can leave the trailing row
      // short (SSR cells hidden by the filter shift the visible count). Fill it
      // with a BOUNDED loop — never recursion, which previously re-entered
      // apply() → renderCatNav() and destroyed the tile mid-click. Stops as
      // soon as the row is full or the catalogue runs out, so the final row on
      // the last page is legitimately allowed to be partial.
      var guard = 0;
      while (guard++ < 12 && _filterIdx < _filterHandles.length) {
        var orphan = _visibleCount() % cols;
        if (!orphan) break;
        if (!_appendUpTo(cols - orphan)) break;
        apply();
        added += cols - orphan;
      }
      updateBatchSentinel();
      return added;
    }

    // Explicit "Load more" button, one batch per click — replaces the earlier
    // IntersectionObserver / scroll-listener path. Auto-scroll was too easy to
    // over-trigger on long filtered sets (a sentinel in view fired repeatedly,
    // stacking dozens of batches faster than the shopper could scroll), so the
    // click-driven model is what we ship: predictable, no runaway load, no CLS.
    function updateBatchSentinel() {
      var moreLeft = !!(_filterHandles && _filterIdx < _filterHandles.length);
      // Queue drained: hide the button but keep the bar (it flips to "All
      // results shown").
      if (!moreLeft) { if (_batchSentinel) _batchSentinel.style.display = 'none'; updateResultsBar(); return; }
      if (!_batchSentinel || !_batchSentinel.isConnected) {
        _batchSentinel = document.createElement('div');
        _batchSentinel.className = 'mh-plp-batch-more-wrap';
        _batchSentinel.innerHTML = '<button type="button" class="mh-plp-batch-more">Load more products</button>';
        grid.insertAdjacentElement('afterend', _batchSentinel);
        var btnEl = _batchSentinel.querySelector('.mh-plp-batch-more');
        btnEl.addEventListener('click', function () {
          btnEl.disabled = true;
          btnEl.textContent = 'Loading…';
          // setTimeout, NOT requestAnimationFrame — rAF is suspended in
          // background/hidden tabs, which left the button stuck on "Loading…"
          // forever. setTimeout still lets the disabled state paint first.
          setTimeout(function () {
            renderFilterBatch(BATCH_SIZE);
            btnEl.disabled = false;
            btnEl.textContent = 'Load more products';
          }, 0);
        });
      }
      // MUST be 'flex' — an inline display:block here overrode the stylesheet's
      // `display:flex` on .mh-plp-batch-more-wrap, which is why justify-content
      // never applied and the button hugged the left edge.
      _batchSentinel.style.display = 'flex';
      updateResultsBar();
    }

    // Results summary ABOVE the grid: "Showing 24 of 100 — 76 more, 20 at a
    // time". Sits directly on top of the product list so the shopper knows the
    // size of the result set before scrolling through it.
    var _resultsBar = null;
    function updateResultsBar() {
      if (!_filterHandles) { if (_resultsBar) _resultsBar.style.display = 'none'; return; }
      if (!_resultsBar || !_resultsBar.isConnected) {
        _resultsBar = document.createElement('div');
        _resultsBar.className = 'mh-plp-results-bar';
        _resultsBar.setAttribute('aria-live', 'polite');
        grid.insertAdjacentElement('beforebegin', _resultsBar);
      }
      var shown = _visibleCount();
      var total = _filterHandles.length;
      var remaining = Math.max(0, total - _filterIdx);
      _resultsBar.style.display = '';
      _resultsBar.innerHTML =
        '<span class="mh-plp-rb-count"><b>' + shown + '</b> of <b>' + total + '</b> products</span>' +
        (remaining
          ? '<span class="mh-plp-rb-more">' + remaining + ' more · ' + Math.min(BATCH_SIZE, remaining) + ' at a time</span>'
          : '<span class="mh-plp-rb-more mh-plp-rb-done">All results shown</span>');
    }

    // Fully drain the queue (used before offer-page numbered pagination which
    // needs to know the total match count to build page buttons).
    function drainFilterBatches() {
      if (!_filterHandles) return;
      while (_filterIdx < _filterHandles.length) renderFilterBatch(BATCH_SIZE);
    }

    // Kick off the catalog prefetch as soon as this script runs — one promise
    // shared by every code path that awaits it (offer eager init + the after-
    // load filter handler below).
    var _catalogPromise = prefetchCatalog();
    // Offer-page eager init must run AFTER _catalogPromise exists (see the
    // hoisting note on initOfferEager).
    initOfferEager();
    _catalogPromise.then(function (ok) {
      if (!ok) return;
      // Catalog is in. Hand the grid over to the batch renderer for EVERY view
      // — filtered or "All" — so the Shopify HTML infinite scroll is retired
      // and "Load more" is the single pager the shopper ever sees. Offer pages
      // are excluded: they drain to a numbered pager in their own init block.
      // Tree and catalog can arrive in either order; whichever is second
      // triggers the re-levelling (the function no-ops once it has run).
      mhAdaptCategoryDepth();
      refreshCatOptions();
      refreshSubOptions();
      renderCatNav();
      // Hand the grid to the catalog batch renderer for offer pages too — it
      // renders straight from the in-memory JSON catalog (instant, priority-
      // ordered via window.__mhCatOrder) instead of the slow SSR page drain.
      run();
    });
  })();

  // admin-uploaded PayLater logo URL (from bnpl_banners.php). Seed it from the
  // shared 'mh_pl_logo' cache (also written by mh-product-card.js) so the on-card
  // PayLater badges paint the LOGO on first render — no fetch wait, no pink text
  // flash on a slow mobile connection.
  var PL_LOGO = (function(){ try { return localStorage.getItem('mh_pl_logo') || ''; } catch (e) { return ''; } })();

  // ── Banner: load admin images, else build the text hero ──────────────
  var root = document.getElementById('mh-plp-banner');
  if (root) {
    var API = 'https://admin.menahub.com/api/bnpl_banners.php';
    // Offer pages (/pages/offers/*) are NOT PayLater: show the offer's OWN hero
    // (title/subtitle/image from the offer config) — never PayLater banner
    // images or "0% interest" copy.
    var _isOfferBn = /\/pages\/offers(\/|$)/.test(location.pathname);
    function clearShim() { var s = root.querySelector('.mh-plp-banner-shim'); if (s) s.remove(); }
    function textHero() {
      clearShim();
      root.classList.add('mh-plp-banner--hero'); // hero sizes to content, not the banner aspect
      var hero = el('div', 'mh-plp-hero');
      var img = root.getAttribute('data-img');
      if (img) { var bg = el('img', 'mh-plp-hero-bg'); bg.src = img; bg.alt = ''; hero.appendChild(bg); }
      var inner = el('div', 'mh-plp-hero-inner');
      var chip = el('span', 'mh-plp-hero-chip');
      var bolt = document.createElement('i'); bolt.className = _isOfferBn ? 'fa-solid fa-tags' : 'fa-solid fa-bolt'; chip.appendChild(bolt);
      chip.appendChild(document.createTextNode(_isOfferBn ? ' Best price · Limited-time offer' : ' 0% interest · 4 months'));
      inner.appendChild(chip);
      inner.appendChild(el('h1', 'mh-plp-hero-title', root.getAttribute('data-title') || (_isOfferBn ? 'Special Offers' : 'Buy Now, Pay Later')));
      inner.appendChild(el('p', 'mh-plp-hero-sub', root.getAttribute('data-sub') || ''));
      hero.appendChild(inner);
      root.appendChild(hero);
    }
    function renderBanners(banners) {
      clearShim();
      var track = el('div', 'mh-plp-banner-track');
      banners.forEach(function (b) {
        var slide = el('div', 'mh-plp-banner-slide');
        var wrap = b.link ? document.createElement('a') : document.createElement('span');
        if (b.link) wrap.href = b.link;
        var mob = b.image_mobile || b.image;
        var im = document.createElement('img'); im.src = b.image; im.alt = ''; im.loading = 'eager';
        if (mob && mob !== b.image) {
          // Desktop vs mobile via <picture>: browser picks the right source.
          var pic = document.createElement('picture');
          var src = document.createElement('source');
          src.media = '(max-width: 600px)'; src.srcset = mob;
          pic.appendChild(src); pic.appendChild(im);
          wrap.appendChild(pic);
        } else {
          wrap.appendChild(im);
        }
        slide.appendChild(wrap); track.appendChild(slide);
      });
      root.appendChild(track);
      if (banners.length > 1) {
        var i = 0;
        setInterval(function () { i = (i + 1) % banners.length; track.style.transform = 'translateX(-' + (i * 100) + '%)'; }, 4000);
      }
    }
    if (_isOfferBn) {
      // Offer page: always render the offer's own hero — no PayLater banner fetch.
      textHero();
    } else {
      fetch(API).then(function (r) { return r.json(); }).then(function (d) {
        PL_LOGO = (d && d.logo) ? d.logo : '';
        try { if (PL_LOGO) localStorage.setItem('mh_pl_logo', PL_LOGO); else localStorage.removeItem('mh_pl_logo'); } catch (e) {}
        if (PL_LOGO) applyLogoToBadges();
        if (d && d.success && d.banners && d.banners.length) renderBanners(d.banners);
        else textHero();
      }).catch(textHero);
    }
  }

  // ── PayLater badge: every product on this page is PayLater-eligible ──
  // Uses the admin-uploaded logo when available, else a default icon+text pill.
  function plBadgeIconFallback(b) {
    var svgNS = 'http://www.w3.org/2000/svg';
    var sv = document.createElementNS(svgNS, 'svg');
    sv.setAttribute('width', '11'); sv.setAttribute('height', '11');
    sv.setAttribute('viewBox', '0 0 24 24'); sv.setAttribute('fill', 'none');
    sv.setAttribute('stroke', '#fff'); sv.setAttribute('stroke-width', '2.6');
    sv.setAttribute('stroke-linecap', 'round'); sv.setAttribute('stroke-linejoin', 'round');
    var rect = document.createElementNS(svgNS, 'rect');
    rect.setAttribute('x', '2'); rect.setAttribute('y', '5');
    rect.setAttribute('width', '20'); rect.setAttribute('height', '14'); rect.setAttribute('rx', '2');
    var ln = document.createElementNS(svgNS, 'line');
    ln.setAttribute('x1', '2'); ln.setAttribute('y1', '10'); ln.setAttribute('x2', '22'); ln.setAttribute('y2', '10');
    sv.appendChild(rect); sv.appendChild(ln);
    b.appendChild(sv);
    b.appendChild(document.createTextNode('PayLater'));
  }
  function plPaintBadge(b) {
    b.replaceChildren();
    if (PL_LOGO) {
      b.classList.add('has-logo');
      var im = document.createElement('img');
      im.className = 'mh-plp-pl-logo'; im.src = PL_LOGO; im.alt = 'PayLater'; im.loading = 'eager';
      b.appendChild(im);
    } else {
      b.classList.remove('has-logo');
      plBadgeIconFallback(b);
    }
  }
  function plBadge() { var b = el('span', 'mh-plp-pl-badge'); plPaintBadge(b); return b; }
  function applyLogoToBadges() {
    document.querySelectorAll('.mh-plp-pl-badge').forEach(plPaintBadge);
  }
  // This whole file is shared with the OFFER pages (offer-store.liquid), which
  // reuse the PayLater DOM/grid but are NOT PayLater — their products should not
  // get a blanket "PayLater" badge. The offer routes are /pages/offers/<slug>
  // (optionally under an /ar locale prefix), so skip badge injection there. The
  // real PayLater page (/pages/paylater) is unaffected.
  var MH_IS_OFFER_PAGE = /\/pages\/offers(\/|$)/.test(location.pathname);
  function wirePlBadges() {
    if (MH_IS_OFFER_PAGE) return;
    document.querySelectorAll('.mh-plp-grid .mh-card-image-wrap').forEach(function (w) {
      if (w.dataset.plBadged) return;
      w.dataset.plBadged = '1';
      w.appendChild(plBadge());
    });
    positionPlpBadges();
  }

  // Place the PayLater logo badge top → middle → bottom on the left edge so it
  // dodges the top-left Deal/Hot Deal badges + countdown timer (which hydrate
  // asynchronously). Mirrors product-card-new's mhPositionPlBadges.
  function positionPlpBadges() {
    document.querySelectorAll('.mh-plp-grid .mh-plp-pl-badge').forEach(function (b) {
      var w = b.parentElement;
      if (!w) return;
      var wr = w.getBoundingClientRect();
      var imgH = wr.height || 260;
      var clusterBottom = 0;
      w.querySelectorAll('.mh-dynamic-badges-img, .mh-deal-countdown').forEach(function (o) {
        if (o.classList.contains('mh-dynamic-badges-img') && o.children.length === 0) return;
        var r = o.getBoundingClientRect();
        if (r.height === 0) return;
        var bottom = r.bottom - wr.top;
        if (bottom > clusterBottom) clusterBottom = bottom;
      });
      b.classList.remove('mh-pl--top', 'mh-pl--middle', 'mh-pl--bottom');
      // Top-left free → top-left; otherwise bottom-left (below image content).
      if (clusterBottom <= 4) b.classList.add('mh-pl--top');
      else                    b.classList.add('mh-pl--bottom');
    });
  }
  // Re-run as the async Deal/Hot Deal badges + countdown timer hydrate. Fixed
  // timeouts alone are unreliable on this page (it also fetches banners +
  // products), so watch the grid for injected badges and re-place then.
  [400, 1000, 1800].forEach(function (ms) { setTimeout(positionPlpBadges, ms); });
  window.addEventListener('load', positionPlpBadges);
  var _plpRz = null;
  window.addEventListener('resize', function () { clearTimeout(_plpRz); _plpRz = setTimeout(positionPlpBadges, 200); });
  if (typeof MutationObserver !== 'undefined') {
    var _plpPend = false;
    var grid = document.querySelector('.mh-plp-grid') || document.body;
    new MutationObserver(function () {
      if (_plpPend) return;
      _plpPend = true;
      // wireImgShimmer() wires newly-appended cards: it clears the per-card
      // image shimmer once each image loads (adds .mh-img-ready) AND calls
      // wirePlBadges() (adds the PayLater badge + repositions). Both are
      // idempotent (dataset.shWired / dataset.plBadged) — needed because
      // infinite-scroll injects cards after the initial wire pass, otherwise the
      // shimmer keeps animating behind the loaded image and badges are missing.
      setTimeout(function () { _plpPend = false; wireImgShimmer(); }, 150);
    }).observe(grid, { childList: true, subtree: true });
  }

  // ── Product image shimmer: clear when each (lazy) image loads ────────
  function wireImgShimmer() {
    wirePlBadges();
    document.querySelectorAll('.mh-plp-grid .mh-card-image-wrap').forEach(function (w) {
      if (w.dataset.shWired) return;
      w.dataset.shWired = '1';
      var img = w.querySelector('img');
      if (!img) { w.classList.add('mh-img-ready'); return; }
      if (img.complete && img.naturalWidth > 0) { w.classList.add('mh-img-ready'); return; }
      img.addEventListener('load', function () { w.classList.add('mh-img-ready'); });
      img.addEventListener('error', function () { w.classList.add('mh-img-ready'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wireImgShimmer);
  else wireImgShimmer();
})();
